const HASH_NAMESPACE = 'propps'

// Automatically open the form if the url has a hash.
// Example hash - #propps:lst_idabc
export const hasAutoOpenHash = (hash: string, listingId: string) => {
  const values = hash.split(':')
  return (
    values.length === 2 &&
    values[0] === `#${HASH_NAMESPACE}` &&
    (values[1] === listingId || values[1] === 'open')
  )
}
